import AnimatedPage from "@/components/AnimatedPage";
import LandingHeader from "@/components/landing/LandingHeader";
import LandingFooter from "@/components/landing/LandingFooter";
import { Helmet } from "react-helmet-async";

const Terms = () => {

  return (
    <AnimatedPage>
      <Helmet>
        <title>Terms of Service | Chito - Chit Fund Management Platform</title>
        <meta name="description" content="Read Chito's Terms of Service to understand the rules and guidelines for using our chit fund management platform. Learn about user responsibilities and our policies." />
        <meta name="keywords" content="chit fund terms, terms of service, chito terms, financial platform terms, chit management rules" />
        <link rel="canonical" href="https://chito.in/terms" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Terms of Service",
            "description": "Terms of Service for the Chito Chit Fund Management Platform",
            "publisher": {
              "@type": "Organization",
              "name": "Chito",
              "logo": "https://chito.in/logo.png"
            }
          })}
        </script>
      </Helmet>
      <div className="min-h-screen flex flex-col">
      <LandingHeader />

        <main className="container border-t mx-auto py-10 px-4 mt-16">
          <article className="max-w-3xl mx-auto text-left">
            <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
            
            <section className="mb-8" aria-labelledby="acceptance">
              <h2 id="acceptance" className="text-xl font-semibold mb-4">1. Acceptance of Terms</h2>
              <p className="mb-4">By accessing or using Chito services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.</p>
              <p>These terms apply to all users of Chito, including but not limited to chit fund organizers, participants, and administrators.</p>
            </section>
            
            <section className="mb-8" aria-labelledby="use-of-services">
              <h2 id="use-of-services" className="text-xl font-semibold mb-4">2. Use of Services</h2>
              <p className="mb-4">Chito provides a platform for managing chit funds, including participant management, payment tracking, and administrative functions.</p>
              <p>Users are responsible for maintaining the confidentiality of their account credentials and for all activities that occur under their account.</p>
            </section>
            
            <section className="mb-8" aria-labelledby="financial-responsibility">
              <h2 id="financial-responsibility" className="text-xl font-semibold mb-4">3. Financial Responsibility</h2>
              <p className="mb-4">Chito is a management platform only and does not assume any responsibility for financial transactions between users.</p>
              <p>Users are responsible for ensuring compliance with all applicable laws and regulations regarding chit funds in their jurisdiction.</p>
            </section>
            
            <section className="mb-8" aria-labelledby="data-privacy">
              <h2 id="data-privacy" className="text-xl font-semibold mb-4">4. Data Privacy</h2>
              <p className="mb-4">User data is handled according to our Privacy Policy, which is incorporated by reference into these Terms of Service.</p>
              <p>By using Chito, you consent to the collection and use of your information as described in the Privacy Policy.</p>
            </section>
            
            <section className="mb-8" aria-labelledby="modifications-to-terms">
              <h2 id="modifications-to-terms" className="text-xl font-semibold mb-4">5. Modifications to Terms</h2>
              <p className="mb-4">Chito reserves the right to modify these terms at any time. We will provide notice of significant changes through the platform.</p>
              <p>Your continued use of Chito after any changes indicates your acceptance of the modified terms.</p>
            </section>
            
            <section className="mb-8" aria-labelledby="termination">
              <h2 id="termination" className="text-xl font-semibold mb-4">6. Termination</h2>
              <p className="mb-4">Chito reserves the right to terminate or suspend access to our services at our sole discretion, without prior notice, for any reason.</p>
              <p>Upon termination, your right to use the services will immediately cease.</p>
            </section>
            
            <section className="mb-8" aria-labelledby="limitation-of-liability">
              <h2 id="limitation-of-liability" className="text-xl font-semibold mb-4">7. Limitation of Liability</h2>
              <p className="mb-4">To the maximum extent permitted by law, Chito shall not be liable for any indirect, incidental, special, or consequential damages resulting from the use or inability to use our services.</p>
            </section>
            
            <section className="mb-8" aria-labelledby="contact">
              <h2 id="contact" className="text-xl font-semibold mb-4">8. Contact</h2>
              <p className="mb-4">If you have any questions about these Terms of Service, please contact us at <a href="mailto:support@chito.in" className="text-primary hover:underline">support@chito.in</a>.</p>
            </section>
            
            <p className="text-sm text-muted-foreground mt-12">Last updated: April 13, 2025</p>
          </article>
        </main>
        
        <LandingFooter />
      </div>
    </AnimatedPage>
  );
};

export default Terms;
